/**
 * Realtime Context
 * 
 * Provides connection state and optional callbacks for the unified realtime provider.
 * Consumed by components that need to know about sync status.
 */

import { createContext, useContext } from "react";

export type ConnectionState = 'connecting' | 'live' | 'degraded';

export interface RealtimeContextValue {
  /**
   * Current connection state:
   * - 'connecting': Initial state, establishing connection
   * - 'live': Successfully subscribed to realtime channel
   * - 'degraded': Connection lost or failed, using fallback polling
   */
  connectionState: ConnectionState;
}

export const RealtimeContext = createContext<RealtimeContextValue>({
  connectionState: 'connecting',
});

export function useRealtimeContext() {
  return useContext(RealtimeContext);
}
